export default "__VITE_ASSET__sAy3iLP9__"